export interface RgbObject {
  red: number;
  green: number;
  blue: number;
}

export type RgbColorType = `rgb(${number}, ${number}, ${number})`;

export enum RgbFormat {
  Color = 'color',
  Object = 'object',
}

export type RgbFormatType = `${RgbFormat}`;
